window.choicesArray = [];

window.initChoices = function initChoices(elementsArr) {
  const choicesDOM = document.querySelector(elementsArr);
  if (choicesDOM) {
    const choicesArr = document.querySelectorAll(`${elementsArr}`);
    for (let i = 0; i < choicesArr.length; i++) {
      if(!choicesArr[i].classList.contains('is-init')) {
        choicesArr[i].classList.add('is-init');

        console.log('init');
        const parentContainer = choicesArr[i].parentNode;

        const choices = new Choices(choicesArr[i], {
          searchEnabled: false,
          itemSelectText: '',
          placeholder: true,
          searchPlaceholderValue: 'Search',

          removeItems: true,
          removeItemButton: true,
          maxItemCount: 5,
          shouldSort: false,
          shouldSortItems: false,
        });

        console.log(parentContainer);

        choicesArray.push(choices);

        const choicesMultipleElement = parentContainer.querySelector(
            ".choices[data-type='select-multiple']"
        );

        if (choicesMultipleElement) {
          choicesMultipleElement.addEventListener('click', () => {
            if (parentContainer.querySelector('.is-open')) {
              choices.hideDropdown();
            }
          });
        }
      }
    }
  }
};

window.getChoice = function getChoice(select) {
  let selectEl =
    typeof select === 'object' ? select : document.querySelector(select);
  let choicesArr = window.choicesArray;
  let targetChoice;
  if (choicesArr) {
    window.choicesArray.forEach((choices) => {
      let choicesSelect = choices.passedElement.element;
      if (choicesSelect == selectEl) {
        targetChoice = choices;
      }
    });
  }
  return targetChoice;
};

window.resetChoice = function resetChoice(select) {
  let choice = getChoice(select);
  if (choice) {
    let startValue = choice.config.choices[0].value;
    choice.setChoiceByValue(startValue);
  }
};

const addNewButtons = document.querySelectorAll('.profile-block__new');

if (addNewButtons.length) {
  addNewButtons.forEach((item) => {
    item.addEventListener('click', () => {
      setTimeout(() => {
        initChoices('[data-choices]');
      }, 1);
    });
  });
}

initChoices('[data-choices]');

/*window.initSelect2Func = function initSelect2Func() {
  $(document).ready(function () {
    const select2Arr = document.querySelectorAll('.select-2');

    $('.select-2:not(.is-init)').select2({
      tags: true,
      dropdownPosition: 'below',
    });

    select2Arr.forEach((select) => {
      if (!select.classList.contains('is-init')) {
        select.classList.add('is-init');
        const parentContainer = select.parentNode;

        const parentContainerWidth = parentContainer.offsetWidth;

        parentContainer.style.maxWidth = `${parentContainerWidth}px`;
      }
    });
  });
};
initSelect2Func();*/

window.initSelect2Func = function initSelect2Func() {
  $(document).ready(function () {
    const select2Arr = document.querySelectorAll('.select-2');
    const placeholderText = 'Type here...';

    $('.select-2:not(.is-init)').select2({
      tags: true,
      dropdownPosition: 'below',
      placeholder: placeholderText,
      createTag: function () {
        return null;
      }
    });

    select2Arr.forEach((select) => {
      if (!select.classList.contains('is-init')) {
        select.classList.add('is-init');
        const parentContainer = select.parentNode;
        const placeholderField = parentContainer.querySelector(
          '.select2-search__field'
        );

        const parentContainerWidth = parentContainer.offsetWidth;
        parentContainer.style.maxWidth = `${parentContainerWidth}px`;

        const selectedOptionsContainer = document.createElement('div');
        selectedOptionsContainer.classList.add('selected-options-container');
        parentContainer.appendChild(selectedOptionsContainer);

        const updateSelectedOptionsContainer = () => {
          selectedOptionsContainer.innerHTML = '';

          const selectedOptions = $(select).val() || [];

          selectedOptions.forEach((optionValue) => {
            const optionText = $(select)
              .find(`option[value="${optionValue}"]`)
              .text();

            const optionElement = document.createElement('span');
            optionElement.classList.add('selected-option');
            optionElement.textContent = optionText;

            optionElement.addEventListener('click', () => {
              const currentValues = $(select).val();
              const newValues = currentValues.filter(
                (value) => value !== optionValue
              );

              $(select).val(newValues).trigger('change');
            });

            selectedOptionsContainer.appendChild(optionElement);
          });

          if (selectedOptions.length > 0) {
            selectedOptionsContainer.style.marginTop = '10px';
            if (placeholderField) {
              placeholderField.placeholder = placeholderText;
            }
          } else {
            selectedOptionsContainer.style.marginTop = '0px';
            if (placeholderField) {
              placeholderField.placeholder = placeholderText;
            }
          }
        };

        $(select).on('change', updateSelectedOptionsContainer);

        updateSelectedOptionsContainer();
      }
    });
  });
};

initSelect2Func();

window.customSelectsLogic = function customSelectsLogic() {
  const defaultCustomSelect = document.getElementsByClassName(
    'default-custom-select'
  )[0];
  if (defaultCustomSelect) {
    const defaultCustomSelectArr = document.querySelectorAll(
      '.default-custom-select'
    );

    defaultCustomSelectArr.forEach((customSelect, i) => {
      const parentContainer = customSelect.parentElement;

      if (parentContainer.classList.contains('is-open')) {
        customSelect.classList.add('active');
      }

      if (!customSelect.classList.contains('is-init')) {
        customSelect.classList.add('is-init');

        const zIndexValue = defaultCustomSelectArr.length - i;
        customSelect.style.zIndex = zIndexValue + 10;

        const customSelectPlaceholder = customSelect.querySelector(
          '.default-custom-select__placeholder'
        );
        const customSelectList = customSelect.querySelector(
          '.default-custom-select__list'
        );
        const customSelectPlaceholderTextContent = customSelect.querySelector(
          '.default-custom-select__placeholder'
        ).textContent;
        customSelectPlaceholder.setAttribute(
          'data-original-placeholder',
          customSelectPlaceholderTextContent
        );

        customSelect.addEventListener('click', (e) => {
          if (!customSelect.classList.contains('active')) {
            customSelect.classList.add('active');
            parentContainer.classList.add('is-open');
          } else {
            if (
              !e.target.classList.contains('default-custom-select__list') &&
              !e.target.closest('.default-custom-select__list')
            ) {
              customSelect.classList.remove('active');
              parentContainer.classList.remove('is-open');
            }
          }
        });

        document.addEventListener('click', (event) => {
          if (
            !customSelectList.contains(event.target) &&
            !customSelect.contains(event.target) &&
            !event.target.closest('.default-custom-select__list')
          ) {
            customSelect.classList.remove('active');
            parentContainer.classList.remove('is-open');
          }
        });

        const checkboxesSelect = customSelect.querySelectorAll(
          'input[type="checkbox"]'
        );

        function placeholderCheck() {
          const checkedCount = customSelect.querySelectorAll(
            'input[type="checkbox"]:checked'
          ).length;
          /*console.log(
            customSelect.querySelectorAll('input[type="checkbox"]:checked')
          );*/

          if (checkedCount === 1) {
            const checkedItem = customSelect.querySelector(
              'input[type="checkbox"]:checked'
            );
            customSelectPlaceholder.textContent =
              checkedItem.nextElementSibling.nextElementSibling.textContent;
          } else {
            customSelectPlaceholder.textContent =
              checkedCount > 0
                ? `${checkedCount} items selected`
                : customSelectPlaceholderTextContent;
          }

          const notCheckedInputArr = customSelect.querySelectorAll(
            'input[type="checkbox"]:not(:checked)'
          );
          if (notCheckedInputArr.length > 0) {
            for (let j = 0; j < notCheckedInputArr.length; j++) {
              notCheckedInputArr[j].parentElement.classList.remove(
                'is-checked'
              );
            }
          }

          if (checkedCount > 0) {
            const checkedInputArr = customSelect.querySelectorAll(
              'input[type="checkbox"]:checked'
            );
            checkedInputArr.forEach((checkedInput) => {
              const parentEl = checkedInput.parentElement;
              parentEl.classList.add('is-checked');
            });
          }
        }

        function allChecked(checkbox) {
          const checkboxAll = customSelect.querySelector(
            'input[type="checkbox"][value="all"]'
          );
          if (checkbox.value === 'all' && checkbox.checked) {
            console.log(1);
            for (let j = 0; j < checkboxesSelect.length; j++) {
              checkboxesSelect[j].checked = true;
            }
          } else if (checkbox.value === 'all' && checkbox.checked === false) {
            console.log(2);
            for (let j = 0; j < checkboxesSelect.length; j++) {
              checkboxesSelect[j].checked = false;
            }
          } else if (checkboxAll.checked) {
            checkboxAll.click();
          }
          console.log(checkboxAll);
        }

        checkboxesSelect.forEach((checkbox) => {
          checkbox.addEventListener('change', () => {
            allChecked(checkbox);
            placeholderCheck();
          });
        });

        const checkboxes = document.querySelectorAll('input[type="checkbox"]');
        for (let j = 0; j < checkboxes.length; j++) {
          checkboxes[j].addEventListener('change', () => {
            /*allChecked(checkboxes[j]);*/
            placeholderCheck();
          });
        }

        placeholderCheck();
      }
    });
  }
};
customSelectsLogic();

window.initFieldChoices = function initChoices(elementsArr) {
  const choicesDOM = document.querySelector(elementsArr);
  if (choicesDOM) {
    const choicesArr = document.querySelectorAll(`${elementsArr}`);
    for (let i = 0; i < choicesArr.length; i++) {
      if (!choicesArr[i].classList.contains('is-init')) {
        choicesArr[i].classList.add('is-init');

        const parentContainer = choicesArr[i].parentNode.parentNode;
        const newOptionEl = parentContainer.querySelector(
          '.profile-block__new-option'
        );

        const choices = new Choices(choicesArr[i], {
          searchEnabled: false,
          itemSelectText: '',
          placeholder: true,
          removeItems: true,
          removeItemButton: true,
          maxItemCount: 5,
          shouldSort: false,
          shouldSortItems: false,
        });

        choicesArr[i].addEventListener('change', function () {
          const selectedValue = choicesArr[i].value;
          console.log(choicesArr[i].value);

          if (selectedValue === 'radio' || selectedValue === 'checkboxes') {
            newOptionEl?.classList.remove('is-hidden');
          } else {
            newOptionEl?.classList.add('is-hidden');
          }
        });

        const initialValue = choicesArr[i].value;
        if (initialValue === 'radio' || initialValue === 'checkboxes') {
          newOptionEl?.classList.remove('is-hidden');
        } else {
          newOptionEl?.classList.add('is-hidden');
        }
      }
    }
  }
};

initFieldChoices('[data-field-choices]');
